import React, { lazy, Suspense } from "react";
import { APP_SHELL_CLASS } from "../Constants/layout";

const DashboardPage = lazy(() => import("../UserPages/DashboardPage"));
const FormsPage = lazy(() => import("../UserPages/FormsPage"));
const CreateFormPage = lazy(() => import("../UserPages/CreateFormPage"));
const EditFormPage = lazy(() => import("../UserPages/EditFormPage"));
const FormDetailsPage = lazy(() => import("../UserPages/FormDetailsPage"));
const QuerysPage = lazy(() => import("../UserPages/QuerysPage"));
const NotesPage = lazy(() => import("../UserPages/NotesPage"));
const ProfilePage = lazy(() => import("../UserPages/ProfilePage"));
const SupportPage = lazy(() => import("../UserPages/SupportPage"));
const BillingPage = lazy(() => import("../UserPages/BillingPage"));

/** Minimal existing-style loader — no redesign. */
export const RouteFallback = () => (
  <div
    className={`${APP_SHELL_CLASS} flex items-center justify-center`}
    role="status"
    aria-label="Loading page"
  >
    <div className="flex flex-col items-center gap-3">
      <div className="size-10 border-4 border-[#0B1C2D]/10 border-t-[#E63946] rounded-full animate-spin" />
      <p className="text-[#0B1C2D] text-xs font-bold uppercase tracking-widest">
        Loading…
      </p>
    </div>
  </div>
);

export const withRouteSuspense = (element) => (
  <Suspense fallback={<RouteFallback />}>{element}</Suspense>
);

export const RouterItems = [
  {
    link: "/dashboard",
    name: "Dashboard",
    page: withRouteSuspense(<DashboardPage />),
  },
  {
    link: "/forms",
    name: "My Forms",
    page: withRouteSuspense(<FormsPage />),
  },
  {
    link: "/forms/create",
    name: "Create Form",
    page: withRouteSuspense(<CreateFormPage />),
  },
  {
    link: "/forms/edit/:formId",
    name: "Edit Form",
    page: withRouteSuspense(<EditFormPage />),
  },
  {
    link: "/forms/:formId",
    name: "Form Details",
    page: withRouteSuspense(<FormDetailsPage />),
  },
  {
    link: "/queries",
    name: "Queries",
    page: withRouteSuspense(<QuerysPage />),
  },
  {
    link: "/notes",
    name: "Notes",
    page: withRouteSuspense(<NotesPage />),
  },
  {
    link: "/myprofile",
    name: "My Profile",
    page: withRouteSuspense(<ProfilePage />),
  },
  {
    link: "/support",
    name: "Help & Support",
    page: withRouteSuspense(<SupportPage />),
  },
  {
    link: "/plans",
    name: "Plans",
    page: withRouteSuspense(<BillingPage />),
  },
];
